<template>
  <div v-if="optionsReady && showNewsletterModal" class="newsletter-modal-mask" tabindex="0" @keydown.esc="closeModal('close')">
    <div class="newsletter-modal-wrapper-close" @click="closeModal('close')"></div>
    <div class="newsletter-modal-wrapper">
      <div class="newsletter-modal-container">
        <div class="newsletter-modal-close">
          <button class="newsletter-modal-default-button" @click="closeModal('close')">X</button>
        </div>
        <div class="newsletter-modal-content">
          <h2 v-text="options.newsletter_modal_title"></h2>

          <div class="rulemailer-subscriber-form">
            <form ref="newsletterSignup" @submit.prevent="handleNewsletterSignup" id="rule-optin-form" action="https://app.rule.io/subscriber-form/subscriber" target="_blank" method="POST">
              <input type="hidden" value="36555" name="tags[]">
              <input type="hidden" name="token" value="9c98708c-d50b816-1e87530-b14380d-80c34b8-019">
              <label>E-post</label>
              <input type="email" placeholder="E-post" name="rule_email" required="required">
              <label>Namn</label>
              <input type="text" placeholder="Namn" name="fields[Person.Fornamn]">
              <label>Organisation/företag</label>
              <input type="text" placeholder="Organisation/företag" name="fields[Person.Organisation]">
              <div>
                <input type="checkbox" name="confirmation" required>
                <span>Jag godkänner personuppgiftshantering. </span>
                <a href="https://primegroup.com/article/gdpr-policy/" target="_blank">GDPR Policy</a>
              </div>
              <label class="rulemailer-email-check">Are you machine?</label>
              <input type="checkbox" name="email_field" class="rulemailer-email-check" value="1" tabindex="-1" autocomplete="off">
              <input type="hidden" name="language" value="sv">
              <button type="submit">Skicka</button>
            </form>
          </div>

          <div class="newsletter-field">
            <a @click="closeModal('forever')" v-text="options.newsletter_modal_close_message"></a>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  props: ["blockdata"],
  name: "newsletter-modal",
  data() {
    return {
      options: null,
      optionsReady: false,
      showNewsletterModal: false,
    };
  },
  mounted(){
    this.fetchData();
    document.body.addEventListener('keydown', e => {
      if (e.keyCode === 27) {
        this.$emit('close')
      }
    });
    this.$root.$on('forceOpenModal', () => {
      this.openNewsletterModal()
    });
  },
  methods: {
    fetchData: function() {
      var self = this;
      $.get(
        self.$root.apiUrl + "wp-json/acf/v3/options/options",
        function(response) {
          self.options = response.acf;
          self.optionsReady = true;
          self.showNewsletterModal = self.options.show_newsletter_modal;
          if (typeof(Storage) !== "undefined") {
            if(localStorage.getItem('hideNewsletterModal') === 'yes') {
              if(localStorage.getItem('hideNewsletterModalUntil') >= moment().format('YYYY-MM-DDTHH:mm:ss')) {
                self.showNewsletterModal = false;
              }
            }
          }
        }
      )
        .done(function() {})
        .fail(function() {});
    },
    handleNewsletterSignup: function() {
     this.closeModal('forever');
     this.$refs.newsletterSignup.submit();
    },
    closeModal: function(duration) {
      let hideDate = moment().add(1, 'days').format('YYYY-MM-DDTHH:mm:ss');
      if(duration === 'forever') {
        hideDate = moment().add(10, 'years').format('YYYY-MM-DDTHH:mm:ss');
      }

      if (typeof(Storage) !== "undefined") {
        localStorage.setItem('hideNewsletterModal', 'yes');
        localStorage.setItem('hideNewsletterModalUntil', hideDate);
      }
      this.showNewsletterModal = false;
    },
    openNewsletterModal: function() {
      if (typeof(Storage) !== "undefined") {
        localStorage.setItem('hideNewsletterModal', 'no');
        localStorage.setItem('hideNewsletterModalUntil', null);
      }
      this.showNewsletterModal = true;

    }
  }
}
</script>



// WEBPACK FOOTER //
// NewsletterModal.vue?8fe30730